"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.cloneInstanceBinding = cloneInstanceBinding;
const cloneBindingCache_1 = require("./cloneBindingCache");
/**
 * Clones an InstanceBinding
 */
function cloneInstanceBinding(binding) {
    return {
        cache: (0, cloneBindingCache_1.cloneBindingCache)(binding.cache),
        id: binding.id,
        implementationType: binding.implementationType,
        isSatisfiedBy: binding.isSatisfiedBy,
        moduleId: binding.moduleId,
        onActivation: binding.onActivation,
        onDeactivation: binding.onDeactivation,
        scope: binding.scope,
        serviceIdentifier: binding.serviceIdentifier,
        type: binding.type,
    };
}
//# sourceMappingURL=cloneInstanceBinding.js.map